var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"parentProps":_vm.parentProps}},[_c('el-input',_vm._b({attrs:{"prefix-icon":"el-icon-full-screen"},on:{"change":_vm.changeHandler},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},'el-input',{placehoder: _vm.placehoder, size: _vm.size, border: _vm.border, clearable: _vm.clearable},false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }